import clsx from "clsx"
import { FC, PropsWithChildren, memo } from "react"
import { IOutlinedText } from "."
import styles from "./OutlinedText.module.scss"

const OutlinedTextComponent: FC<PropsWithChildren<IOutlinedText>> = ({
  children,

  text,
  className,
  ...rest
}) => {
  return (
    <div
      className={clsx("outlinedText", styles.OutlinedText, className)}
      {...rest}
    >
      <div className={clsx(styles.OutlinedText_fakeText)}>{children}</div>
      <div
        data-text={text || children?.toString()}
        className={clsx(styles.OutlinedText_content)}
      >
        <div className={styles.OutlinedText_shadow}>{children}</div>
        <span>{children}</span>
      </div>
    </div>
  )
}

export const OutlinedText = memo(OutlinedTextComponent)
